<div class="msg-atch-tmp" *ngIf="dataSource.length > 0; else noTemplateView">
  <div *ngFor="let row of dataSource; let i = index ; trackBy: trackByTemplateId" class="template-item">
    <div class="template-header">
      <div class="left-section">
        <owc-radio name="template-radio-group" class="template-radio" [disabled]="row.iconSets === 'yes-icon'"
          [checked]="isInitialized && selection.selected && selection.selected.templateId === row.templateId"
          (click)="onRadioClick(row, $event)" (change)="onRadioChange(row, $event)">
          {{ row?.templateDetails?.templateSubject || row?.templateSubject }}
        </owc-radio>

      </div>

      <div class="action-button">
        <owc-icon-button family="outlined" [id]="'menu-anchor-' + i" icon="more_vertical"></owc-icon-button>
        <owc-menu #menu [anchor]="'menu-anchor-' + i" limit="3" position="left">
          <owc-list-item (click)="EditMessageTemplate(i); visible = true; closeMenu()">Edit</owc-list-item>
          <owc-list-item
            (click)="deleteMessageFromTemplate(row, i); deleteButtonVisible = true; closeMenu()">Delete</owc-list-item>
        </owc-menu>
      </div>
    </div>

    <div class="template-body" [innerHTML]="row?.templateDetails?.templateBody || row?.templateBody"></div>
    <owc-divider></owc-divider>

    <!-- Delete Modal -->
    <owc-modal-dialog [(ngModel)]="deleteButtonVisible" size="small">
      <div style="padding: 20px;">
        <h4 slot="header">Delete message template</h4>
        <div>
          <owc-typography variant="body2">Are you sure you want to delete this message template from your
            templates?</owc-typography>
        </div>
      </div>
      <owc-component-footer slot="footer">
        <div class="footer-btn">
          <owc-button class="cancel-btn" (click)="closeDeleteModal()">Cancel</owc-button>
          <owc-button color="primary" (click)="confirmDelete()">Yes, delete</owc-button>
        </div>
      </owc-component-footer>
    </owc-modal-dialog>

    <!-- Edit Modal -->
    <owc-modal-dialog [(ngModel)]="visible">
      <dl-add-own-template-dialog [data]="messageDta" (closeDialog)="visible = false">
      </dl-add-own-template-dialog>
    </owc-modal-dialog>
  </div>
</div>

<ng-template #noTemplateView>
  <p title="No Template present, add new Template.">No Template present, add new Template.</p>
</ng-template>